import { useState } from 'react'
import { toast } from 'react-toastify'
import { updateUserPasswordApi } from '../../apis/profile'
import { handleApiError } from '../../helpers'
import { UpdatePasswordInterface } from '../../interfaces/profile'

type formData = {
  password: string;
  new_password: string;
  confirm_password: string;
};

export const useChangePassword = () => {
  const [submitting, setSubmitting] = useState(false)

  const handleChangePassword = async (values: formData) => {
    const payload = {} as UpdatePasswordInterface

    payload.current_password = values.password
    payload.confirm_password = values.confirm_password
    payload.new_password = values.new_password

    try {
      setSubmitting(true);
      const {data} = await updateUserPasswordApi(payload)
      setSubmitting(false)
      toast.success(data.message)
    } catch (error) {
      console.log("ERROR", error);
      toast.error(handleApiError(error));
      setSubmitting(false)
    }
  }

  return { submitting, handleChangePassword }
}
